<div class="item-details">
  <div class="item-details-header">
    <div class="item-details-header-title">
      <h4 class="item-details__title">
        <a
          class="nextLine overflow-ellipsis"
          (click)="navigateToEntityRecord({ entity: data.suiteType }, 'titleEvent')"
        >
          <span *ngIf="data?.suiteType === 'availability'">
            {{ 'actionsToolbar.suite' | xTranslate | titlecase }}:
          </span>
          {{ data | dataFormatter: { displayFn: config.title } }}
          <ng-container *cbreTogglePoint="showFloorIndexFeatureKey">
            <ng-container *ngIf="!config.removeIdInTitle">
              ({{ data | dataFormatter: { displayFn: config.id } }})
            </ng-container>
          </ng-container>
        </a>
      </h4>
    </div>
    <div class="item-details-header-edit" *ngIf="isEditable">
      <a>
        <mat-icon
          [matMenuTriggerFor]="menu"
          svgIcon="edit"
          aria-hidden="false"
          class="overlay-edit-icon"
          [ngClass]="{ 'hide-overlay-edit-icon': isEdit }"
        ></mat-icon>
      </a>
      <mat-menu class="mat-menu-content toolbar-menu-disabled" #menu="matMenu" xPosition="before">
        <ng-container *ngFor="let overlayMenu of overlayMenus">
          <button
            class="toolbar-menu-item"
            [ngClass]="!!overlayMenu.class ? overlayMenu.class : ''"
            (click)="overlayMenu.action($event)"
            [disabled]="overlayMenu.disabled"
            mat-menu-item
          >
            {{ overlayMenu.disableTranslate ? overlayMenu.text : (overlayMenu.text | xTranslate) }}
          </button>
        </ng-container>
        <button class="toolbar-menu-item" mat-menu-item (click)="deleteNRSpace()" *ngIf="config.remove" l10nTranslate>
          commonLabels.remove
        </button>
      </mat-menu>
    </div>
  </div>

  <div *ngIf="config.progressBar" class="item-details__terms-bar Default">
    <div class="terms">
      <ng-container *ngIf="!totalTermYears; else na">
        <ng-container *ngIf="termDisplayIsMasked; else isNotMasked"> ***** </ng-container>
        <ng-template #isNotMasked>{{ 'overlayDetails.na' | xTranslate }}</ng-template>
      </ng-container>
      <ng-template #na
        >{{ 'overlayDetails.termYears' | xTranslate: { year: totalTermYears.year, month: totalTermYears.month } }}
      </ng-template>
    </div>
    <mat-progress-bar mode="determinate" [ngClass]="overlayBarClass" [value]="termCompletedPer"></mat-progress-bar>
  </div>
  <div class="item-details__content {{ data.suiteType }}" [ngClass]="{ 'edit-mode': isEdit }">
    <div *ngFor="let subset of subsets" class="subsets">
      <div [ngClass]="subset.class">
        <label>
          {{ columns | labelFormatter: subset }}
        </label>
        <label class="required-icon" *ngIf="isEdit && (subset.validators | isRequired)">*</label>
        <ng-container [ngTemplateOutlet]="!isEdit ? labels : editForm" [ngTemplateOutletContext]="{ itemData: subset }">
        </ng-container>
      </div>
    </div>
    <div *ngFor="let item of notesUpdate" class="subsets nowrap">
      <div [ngClass]="item.class">
        <label> {{ columns | labelFormatter: item }}</label
        ><label class="required-icon" *ngIf="isEdit && (item.validators | isRequired)">*</label>
        <ng-container [ngTemplateOutlet]="!isEdit ? labels : editForm" [ngTemplateOutletContext]="{ itemData: item }">
        </ng-container>
      </div>
    </div>
    <div class="footer subsets nowrap" *ngIf="!!footer">
      <div [ngClass]="footer.class">
        <div>
          {{
            data
              | dataFormatter
                : footer
                : { defaultTxt: 'overlayDetails.noLastUpdateInfo' | xTranslate, label: footer.label }
          }}
        </div>
      </div>
    </div>
  </div>
  <div class="overlay-actions" *ngIf="isEdit">
    <a>
      <span (click)="cancelEdit()" class="overlay-actions-cancel"
        ><mat-icon svgIcon="close" aria-hidden="false" class="overlay-edit-icon"></mat-icon
        >{{ 'commonLabels.cancel' | xTranslate }}</span
      ></a
    >
    <span
      class="overlay-actions-save"
      (click)="save()"
      [ngClass]="{ 'active-icon': overlayFormGroup.valid && this.overlayFormGroup.dirty }"
      ><a>
        <mat-icon
          svgIcon="save-disabled"
          *ngIf="!overlayFormGroup.valid || !this.overlayFormGroup.dirty"
          aria-hidden="false"
          class="overlay-edit-icon-disabled"
        ></mat-icon>
        <mat-icon
          svgIcon="save"
          *ngIf="overlayFormGroup.valid && this.overlayFormGroup.dirty"
          aria-hidden="false"
          class="overlay-edit-icon"
        ></mat-icon
      ></a>
      <span> {{ 'commonLabels.save' | xTranslate }}</span>
    </span>
  </div>
</div>

<ng-template #labels let-itemData="itemData">
  <div *ngIf="lookupFlag" (click)="navigateToEntityRecord(itemData.navigationToEntity, 'bodyEvent')">
    <div *ngIf="!itemData.isLinkedOpportunities; else opportunity">
      <span>{{ data | dataFormatter: itemData : itemData.options }}</span>
      <span *ngIf="itemData.estimated"> &nbsp; | &nbsp;{{ data | dataFormatter: itemData.estimated }}</span>
    </div>
  </div>
</ng-template>

<ng-template #editForm let-itemData="itemData">
  <div class="form-container" *ngIf="itemData.dataField; else defaultInput">
    <sp-input-fields
      class="form-container__item optselect"
      [overlayFormControl]="
        itemData.formGroup
          ? overlayFormGroup.controls[itemData.formGroup].get(itemData.dataField)
          : overlayFormGroup.get(itemData.dataField)
      "
      [optionValues]="itemData.values"
      [inputType]="itemData.inputType"
      [value]="data | dataFormatter: itemData : defaultOptions"
      (emitNumericData)="emitNumericData($event, itemData.dataField)"
    ></sp-input-fields>
    <sp-input-fields
      *ngIf="itemData.unit"
      class="form-container__item optselect"
      [overlayFormControl]="overlayFormGroup.controls[itemData.unit.formGroup].get(itemData.unit.dataField)"
      [optionValues]="itemData.unit.values"
      [inputType]="itemData.unit.inputType"
      [value]="data | dataFormatter: itemData.unit : defaultOptions"
      (emitNumericData)="emitNumericData($event, itemData.dataField)"
    ></sp-input-fields>
    <sp-input-fields
      *ngIf="itemData.estimated"
      class="form-container__item optselect"
      [overlayFormControl]="overlayFormGroup.controls[itemData.estimated.formGroup].get(itemData.estimated.dataField)"
      [optionValues]="itemData.estimated.values"
      [inputType]="itemData.estimated.inputType"
      [value]="data | dataFormatter: itemData.estimated : defaultOptions"
    ></sp-input-fields>
    <!-- 
      formGroup error messages...
      overlayFormGroup is made of formControls and formGroups condition below is
      to make sure to always used a formControl instance...
    -->
    <ng-container
      *ngTemplateOutlet="
        errorMsg;
        context: {
          formGroup: itemData.formGroup
            ? overlayFormGroup.controls[itemData.formGroup]
            : overlayFormGroup.get(itemData.dataField),
        }
      "
    ></ng-container>
  </div>
  <ng-template #defaultInput>
    <div class="form-container">
      <div class="form-container__item" *ngIf="!itemData.isLinkedOpportunities; else opportunity">
        <input [disabled]="true" [value]="data | dataFormatter: itemData : itemData.options" />
      </div>
    </div>
  </ng-template>
</ng-template>
<ng-template #opportunity>
  <sp-opportunity
    [isConfidential]="isConfidential"
    [isCIQDown]="isCIQDown"
    [hasAccessToOpportunities]="hasAccessToOpportunities"
    [opportunities]="opportunities"
    (navigate)="navigateToCIQ($event)"
  ></sp-opportunity>
</ng-template>
<ng-template #errorMsg let-formGroup="formGroup">
  <span class="error-message" [spFormErrorMsg]="formGroup"></span>
</ng-template>
